export const SectionsIds = {
    ABOUT: 'about',
    EVENTS: 'events',
    COLLECTIONS: 'collections',
} as const;
